(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sr-routine-builder"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.customElements.get('sr-routine-builder')) return;

  if (window.console && console.info) console.info('[sr-routine-builder] versión: compact-ui (v3)');

  var LAST_SUBMIT = 0;
  var SUBMIT_WINDOW = 1200;

  var OB = String.fromCharCode(123);
  var CB = String.fromCharCode(125);
  var DEFAULT_MONEY = '$' + OB + OB + 'amount' + CB + CB;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents.replace(/[^0-9-]/g, ''), 10);
    if (isNaN(cents)) cents = 0;
    format = format || DEFAULT_MONEY;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = (thousands == null) ? ',' : thousands;
      decimal = (decimal == null) ? '.' : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? (decimal + parts[1]) : '';
      return dollars + rest;
    }
    var match = format.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function discountedCents(cents, discount) {
    return cents - Math.floor((cents * discount) / 100);
  }

  class SrRoutineBuilder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.moneyFormat = (this.dataset.moneyFormat || DEFAULT_MONEY).replace(/<[^>]*>/g, '');
      this.discount = parseInt(this.dataset.discount, 10) || 0;
      this.maxExtras = parseInt(this.dataset.maxExtras, 10) || 3;
      this.discountCode = (this.dataset.discountCode || '').trim();
      this.blockId = this.dataset.blockId || '';
      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.busy = false;

      this.extrasEl = this.querySelector('[data-sr-rb-extras]');
      this.countEl = this.querySelector('[data-sr-rb-count]');
      this.saveEl = this.querySelector('[data-sr-rb-save]');
      this.totalEl = this.querySelector('[data-sr-rb-total]');
      this.totalWasEl = this.querySelector('[data-sr-rb-total-was]');
      this.ctaEl = this.querySelector('[data-sr-rb-add]');
      this.ctaLabelEl = this.querySelector('[data-sr-rb-cta-label]');
      this.spinnerEl = this.querySelector('.sr-rb__spinner');
      this.liveEl = this.querySelector('[data-sr-rb-live]');

      this.labelItems = this.dataset.labelItems || 'items seleccionados';
      this.labelSave = this.dataset.labelSave || 'Ahorras';
      this.labelButton = this.dataset.labelButton || 'LLEVAR · ITEMS AL CARRO';

      var self = this;
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-sr-rb-add]')) self.onAdd();
      });

      this.recalc();
    }

    onChange() { this.recalc(); }

    rowState(row) {
      var check = row.querySelector('[data-sr-rb-check]');
      var variantEl = row.querySelector('[data-sr-rb-variant]');
      if (!variantEl) return null;
      var isExtra = row.dataset.extra === 'true';
      var cents, variantId;
      if (variantEl.tagName === 'SELECT') {
        var opt = variantEl.options[variantEl.selectedIndex];
        cents = parseInt(opt ? opt.dataset.price : 0, 10) || 0;
        variantId = variantEl.value;
      } else {
        cents = parseInt(variantEl.dataset.price, 10) || 0;
        variantId = variantEl.value;
      }
      var finalCents = isExtra ? discountedCents(cents, this.discount) : cents;
      return {
        row: row,
        checked: check && check.checked && !check.disabled,
        isExtra: isExtra,
        variantId: variantId,
        original: cents,
        final: finalCents
      };
    }

    updateRowPrices(state) {
      var wasEl = state.row.querySelector('[data-sr-rb-was]');
      var nowEl = state.row.querySelector('[data-sr-rb-now]');
      if (nowEl) nowEl.textContent = formatMoney(state.final, this.moneyFormat);
      if (wasEl) wasEl.textContent = formatMoney(state.original, this.moneyFormat);
    }

    recalc() {
      var rows = this.querySelectorAll('[data-sr-rb-row]');
      var count = 0, sumOriginal = 0, sumFinal = 0;
      var self = this;
      rows.forEach(function (row) {
        var st = self.rowState(row);
        if (!st) return;
        self.updateRowPrices(st);
        if (st.checked) {
          count++;
          sumOriginal += st.original;
          sumFinal += st.final;
        }
      });
      var saved = sumOriginal - sumFinal;

      this.countEl.textContent = count + ' ' + this.labelItems;
      this.totalEl.textContent = count ? formatMoney(sumFinal, this.moneyFormat) : '—';

      if (saved > 0) {
        this.totalWasEl.hidden = false;
        this.totalWasEl.textContent = formatMoney(sumOriginal, this.moneyFormat);
        this.saveEl.hidden = false;
        this.saveEl.textContent = this.labelSave + ' ' + formatMoney(saved, this.moneyFormat);
      } else {
        this.totalWasEl.hidden = true;
        this.saveEl.hidden = true;
      }

      this.ctaEl.disabled = (count === 0) || this.busy;
      this.ctaLabelEl.textContent = this.labelButton.replace('·', String(count));
    }

    collectItems() {
      var items = [];
      var self = this;
      this.querySelectorAll('[data-sr-rb-row]').forEach(function (row) {
        var st = self.rowState(row);
        if (st && st.checked && st.variantId) {
          items.push({ id: Number(st.variantId), quantity: 1 });
        }
      });
      return items;
    }

    status(msg) { if (this.liveEl) this.liveEl.textContent = msg || ''; }

    applyDiscount() {
      if (!this.discountCode) return;
      try {
        fetch('/discount/' + encodeURIComponent(this.discountCode), { method: 'GET', credentials: 'same-origin' })
          .catch(function () {});
      } catch (e) {}
    }

    onAdd() {
      var now = Date.now();
      if (this.busy || (now - LAST_SUBMIT) < SUBMIT_WINDOW) return;
      var items = this.collectItems();
      var self = this;
      if (!items.length) { this.status('Selecciona al menos un producto disponible.'); return; }
      LAST_SUBMIT = now;
      this.setBusy(true);

      this.cartAddItems(items)
        .then(function (result) {
          self.setBusy(false);
          if (result.added > 0) {
            self.applyDiscount();
            self.refreshCart();
            self.status('✓ Carrito: ' + (result.cart.item_count || result.added) + ' productos');
          } else {
            self.status(result.error || 'No se pudo agregar al carrito. Revisa el stock e intenta de nuevo.');
          }
        })
        .catch(function (err) {
          self.setBusy(false);
          var msg = (err && err.message) ? err.message : String(err);
          self.status('No se pudo agregar (' + msg + ').');
          if (window.console && console.error) console.error('[sr-routine-builder] error al agregar:', err);
        });
    }

    cartAddItems(items) {
      var self = this;
      var added = 0;
      var error = '';
      var chain = Promise.resolve();
      items.forEach(function (it) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append('id', it.id);
          fd.append('quantity', it.quantity);
          return fetch(self.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          }).then(function (r) {
            return r.text().then(function (txt) {
              var b = {};
              try { b = JSON.parse(txt); } catch (e) {}
              if (r.ok && !b.status) {
                added++;
              } else {
                error = b.description || b.message || ('Error ' + r.status);
                if (window.console && console.warn) console.warn('[sr-routine-builder] no se agregó la variante ' + it.id + ':', b);
              }
            });
          });
        });
      });
      return chain.then(function () {
        return fetch('/cart.js?t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { cart: cart, added: added, error: error }; })
          .catch(function () { return { cart: { item_count: added }, added: added, error: error }; });
      });
    }

    refreshCart() {
      if (!window.SRCart) return;
      window.SRCart
        .refresh({ action: 'add', source: this, sourceId: 'sr-routine-builder' })
        .catch(function () {})
        .then(function () { window.SRCart.openDrawer(); });
    }

    setBusy(state) {
      this.busy = state;
      if (this.ctaEl) {
        this.ctaEl.setAttribute('aria-busy', state ? 'true' : 'false');
        this.ctaEl.disabled = state || (this.collectItems().length === 0);
      }
      if (this.spinnerEl) this.spinnerEl.hidden = !state;
    }
  }

  window.customElements.define('sr-routine-builder', SrRoutineBuilder);
})();
  } catch(e) { console.error(e); }
})();

})();
